/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingChange } from './BookingChange';
import {
    BookingChangeFromJSON,
    BookingChangeFromJSONTyped,
    BookingChangeToJSON,
    BookingChangeToJSONTyped,
} from './BookingChange';

/**
 *
 * @export
 * @interface BookingCollaboration
 */
export interface BookingCollaboration {
    /**
     *
     * @type {boolean}
     * @memberof BookingCollaboration
     */
    canManage: boolean;
    /**
     *
     * @type {boolean}
     * @memberof BookingCollaboration
     */
    canRequestChanges: boolean;
    /**
     *
     * @type {number}
     * @memberof BookingCollaboration
     */
    revision: number;
    /**
     *
     * @type {Array<BookingChange>}
     * @memberof BookingCollaboration
     */
    requests: Array<BookingChange>;
    /**
     *
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BookingCollaboration
     */
    lineup: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the BookingCollaboration interface.
 */
export function instanceOfBookingCollaboration(value: object): value is BookingCollaboration {
    if (!('canManage' in value) || value['canManage'] === undefined) return false;
    if (!('canRequestChanges' in value) || value['canRequestChanges'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('lineup' in value) || value['lineup'] === undefined) return false;
    return true;
}

export function BookingCollaborationFromJSON(json: any): BookingCollaboration {
    return BookingCollaborationFromJSONTyped(json, false);
}

export function BookingCollaborationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingCollaboration {
    if (json == null) {
        return json;
    }
    return {

        'canManage': json['can_manage'],
        'canRequestChanges': json['can_request_changes'],
        'revision': json['revision'],
        'requests': ((json['requests'] as Array<any>).map(BookingChangeFromJSON)),
        'lineup': json['lineup'],
    };
}

  export function BookingCollaborationToJSON(json: any): BookingCollaboration {
      return BookingCollaborationToJSONTyped(json, false);
  }

  export function BookingCollaborationToJSONTyped(value?: BookingCollaboration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'can_manage': value['canManage'],
        'can_request_changes': value['canRequestChanges'],
        'revision': value['revision'],
        'requests': ((value['requests'] as Array<any>).map(BookingChangeToJSON)),
        'lineup': value['lineup'],
    };
}
